import { render } from "./OutlineBlock.vue?vue&type=template&id=2ebc1a52&ts=true"
import script from "./OutlineBlock.vue?vue&type=script&lang=ts"
export * from "./OutlineBlock.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__